import breakpoints from './../../helpers/breakpoints.js';

export default {
    data() {
        return {
            media: null
        };
    },
    created: function () {
        this.media = window.matchMedia('(max-width: ' + breakpoints.tabletPortrait + 'px)');
        this.media.addListener(this.breakpointsUpdateMedia);
    },
    computed: {
        breakpointTabletPortrait: function () {
            return !!this.media.matches;
        }
    },
    methods: {
        breakpointsUpdateMedia(mm){
            this.media = mm;
            if( typeof this.afterBreakpointsUpdateMedia === 'function' ){
                this.afterBreakpointsUpdateMedia();
            }
        }
    }
};



// WEBPACK FOOTER //
// ./assets/js/components/Mixins/BreakpointMixins.js